import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { CHeader } from "./c/CHeader";
import FeedbackModel from "../../Feedback/FeedbackModel";
import { saveFeedbackForm } from "examsbook-react-sdk/actions/saveFeedback";
import { useSelector, useDispatch } from "react-redux";
import { withStyles } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { useSearchQuery } from "../../../services/SearchQueryContext";
import CHeaderBarContent from "./CHeaderBarContent";
import SideBar from "./SideBar";

/**
 * Main Header component.
 */

function Header(props) {
  const { isFeedbackModelOpen, setIsFeedbackModelOpen } = useSearchQuery();
  const [addHeaderExamModal, setAddHeaderExamModal] = useState(false);
  const { classes, open, handleDrawerClose, handleDrawerOpen } = props;
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();

  function openFeedbackModel() {
    setIsFeedbackModelOpen(true);
  }

  function closeFeedBackModel() {
    setIsFeedbackModelOpen(false);
  }

  function submitFeedbackForm(message) {
    dispatch(saveFeedbackForm({ message: message }));
    closeFeedBackModel();
  }

  function closeExamModel() {
    setAddHeaderExamModal(!addHeaderExamModal);
  }

  useEffect(() => {
    if (
      user?.selectedExams &&
      (user?.selectedExams.length === 0 ||
        (user?.selectedExams.length > 0 && !user?.selectedExam))
    ) {
      setAddHeaderExamModal(true);
    }
  }, [user]);

  return (
    <React.Fragment>
      {!(
        location?.pathname?.includes("quiz/")
      ) || location?.pathname?.includes("reports/") ? (
        <>
          <SideBar
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                openSidebar={open}
          />
          <CHeader classes={classes}>
            <CssBaseline />
            <CHeaderBarContent
                classes={classes}
                open={open}
                handleDrawerOpen={handleDrawerOpen}
                handleAddHeaderExam={closeExamModel}
                openFeedbackModel={openFeedbackModel}
            />
            <FeedbackModel
              isFeedbackModelOpen={isFeedbackModelOpen}
              closeFeedBackModel={closeFeedBackModel}
              submitForm={submitFeedbackForm}
            />
          </CHeader>
        </>
        ) : (
         ""
       )}
    </React.Fragment>
  );
}

const styles = (theme) => ({
  HeaderMenuButton: {
    backgroundColor: "transparent !important",
    '& h6': {
      display: 'flex',
      '& img': {
        height: 'auto !important',
        width: '100px !important'
      }
    },
    "@media (max-width: 1024px)": {
      marginTop: "10px",
    },
    "@media (max-width: 767px)": {
      color: "#2962ff",
      "& svg": {
        fontSize: 30,
        color: "#fff",
      },
    },
  },
});

export default withStyles(styles, { withTheme: true })(Header);